import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function EditorPicks() {
  const editorPicks = articles.filter((a) => a.rating >= 8.5).slice(0, 3);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="text-center mb-10">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          编辑精选
        </h2>
        <p className="text-foreground-500 mt-2 text-sm">精心挑选的高分影视内容，不容错过</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {editorPicks.map((article) => (
          <ArticleCard key={article.id} article={article} />
        ))}
      </div>
    </section>
  );
}